export var generateFaqUrl = function (supportPageUrl, sku, faqId) {
    return supportPageUrl + "/" + sku + "/faq/" + faqId;
};
